(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1279],{

/***/ 3482:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/datenschutz",
      function () {
        return __webpack_require__(8187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1151);
/* harmony import */ var _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4022);
/* harmony import */ var _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7310);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__);
// import node_modules




// import components


// import styles

// define component
var LocalMarkdown = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default().markdown),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_5__/* .MDXProvider */ .Zo, {
            components: {
                StorylinerImage: _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                a: _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
            },
            children: children
        })
    });
};
LocalMarkdown.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LocalMarkdown);


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4090);
// import node_modules



// import components

// define components
var MarkdownImage = function(param) {
    var height = param.height, hasShadow = param.hasShadow, imageId = param.imageId, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "storyliner-markdown-image",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
            hasShadow: hasShadow,
            height: height,
            imageId: imageId,
            title: title,
            width: width
        })
    });
};
MarkdownImage.defaultProps = {
    hasShadow: false
};
MarkdownImage.propTypes = {
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownImage);


/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5676);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import types

// define component
var MarkdownLink = function(param) {
    var children = param.children, href = param.href;
    // storyliner link
    if (href === null || href === void 0 ? void 0 : href.includes("https://storylinerlabs.com")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            className: (_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
            href: href.replace("https://storylinerlabs.com", ""),
            passHref: true,
            children: children
        });
    }
    // external link
    if ((href === null || href === void 0 ? void 0 : href.includes("http")) || (href === null || href === void 0 ? void 0 : href.includes("mailto"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    });
};
MarkdownLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownLink);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 8733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(937);
/* harmony import */ var _TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2__);
// import node_modules



// import styles

// define component
var TableOfContents = function(param) {
    var items = param.items;
    // init func
    var onScrollToSection = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(event, itemId) {
        event.preventDefault();
        var section = document.getElementById(itemId);
        if (section) {
            var offset = 64; // nav height
            window.scroll({
                top: section.offsetTop - offset,
                left: 0,
                behavior: "smooth"
            });
        }
    }, []);
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2___default()["storyliner-toc-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2___default()["storyliner-toc-menu"]),
            children: items.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2___default()["storyliner-toc-item-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_TableOfContents_module_css__WEBPACK_IMPORTED_MODULE_2___default()["storyliner-toc-item"]),
                        onClick: function(event) {
                            return onScrollToSection(event, item.id);
                        },
                        type: "button",
                        children: item.label
                    })
                }, item.id);
            })
        })
    });
};
TableOfContents.propTypes = {
    items: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        label: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (TableOfContents);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7058);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8362);
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable no-alert */ // import node_modules



// import config

// define component
var PrivacyActions = function() {
    // import hooks
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)("components").t;
    // custom func
    var onFbOptOut = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        // because of build
        if (false) {}
        // set localStorage
        localStorage.setItem("adCookies", "opt-out");
        // update cookie status for subdomains
        var baseDomain = _config__WEBPACK_IMPORTED_MODULE_2__/* .cookiesBaseDomain */ ._v;
        var expireAfter = new Date();
        // setting up cookie expire date after a month
        expireAfter.setDate(expireAfter.getDate() + 30);
        // now setup cookie for subdomains
        var cookieStatus = localStorage.getItem("performanceCookies") === "opt-in";
        document.cookie = "rootCookies={ performance: ".concat(cookieStatus, ", ad: false }; domain=").concat(baseDomain, "; expires=").concat(expireAfter, "; path=/");
        // alert an refresh page
        alert(t("PrivacyActions.alerts.facebookPixel"));
        window.location.reload();
    }, [
        t
    ]);
    // handle data changes
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        // get and check button
        var fbOptOutButton = document.getElementById("faOptOut");
        // listen to ga optout event
        if (fbOptOutButton) {
            fbOptOutButton.addEventListener("touchstart", onFbOptOut);
            fbOptOutButton.addEventListener("click", onFbOptOut);
        }
        return function() {
            // listen to ga optout event
            if (fbOptOutButton) {
                fbOptOutButton.removeEventListener("touchstart", onFbOptOut);
                fbOptOutButton.removeEventListener("click", onFbOptOut);
            }
        };
    }, [
        onFbOptOut,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (PrivacyActions);


/***/ }),

/***/ 8187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1151);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4468);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3192);
/* harmony import */ var _components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8325);
/* harmony import */ var _components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6880);
/* harmony import */ var _components_vendors_PrivacyActions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(559);
/* harmony import */ var _components_meta_SEO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8897);
/* harmony import */ var _components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9748);
/* harmony import */ var _components_atoms_TableOfContents__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8733);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8362);
/*@jsxRuntime automatic @jsxImportSource react*/ /*import node_modules*/ /*import types*/ /*import components*/ /*import config*/ /*define layout*/ /*Navbar*/ /*define content*/ 












var MDXLayout = function(param) {
    var children = param.children;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_SEO__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                description: "Datenschutzerkl\xe4rung der Storyliner Labs GmbH. Jetzt lesen…",
                hrefLang: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_PRIVACY_EN */ .gv.WEBSITE_PRIVACY_EN,
                image: "".concat(_config__WEBPACK_IMPORTED_MODULE_11__/* .storylinerRootDomain */ .pk, "/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg"),
                title: "Datenschutzerkl\xe4rung - Storyliner"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_vendors_PrivacyActions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "64px"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "50px"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    cols: "md",
                    children: [
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                            tag: "h1",
                            children: "Datenschutz\xaderkl\xe4rung"
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                            height: "36px"
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                            tag: "h2",
                            children: "\xdcbersicht"
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_TableOfContents__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            items: [
                                {
                                    id: "intro",
                                    label: "Einf\xfchrung"
                                },
                                {
                                    id: "security",
                                    label: "Sicherheitsma\xdfnahmen"
                                },
                                {
                                    id: "data-transfer",
                                    label: "Datenweitergabe"
                                },
                                {
                                    id: "service-provision",
                                    label: "Leistungserbringung"
                                },
                                {
                                    id: "communication",
                                    label: "Kommunikation"
                                },
                                {
                                    id: "data-collection",
                                    label: "Datenerhebung"
                                },
                                {
                                    id: "services",
                                    label: "Verwendete Dienste"
                                }
                            ]
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                            height: "48px"
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: children
                        })
                    ]
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__["default"], {
                bgColor: "desertStorm"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            })
        ]
    });
};
function _createMdxContent(props) {
    var _components = Object.assign({
        h2: "h2",
        p: "p",
        br: "br",
        h3: "h3"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_12__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Kontakt"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Storyliner Labs GmbH",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.br, {}),
                    "\n",
                    "Regerstra\xdfe 70a",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.br, {}),
                    "\n",
                    "22761 Hamburg",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.br, {}),
                    "\n",
                    "Deutschland"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Handelsregister Hamburg, HRB 147180",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.br, {}),
                    "\n",
                    "Gesch\xe4ftsf\xfchrer: Michael Schmitt"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Telefonnummer: +49 40 22859631",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.br, {}),
                    "\n",
                    "E-Mail-Adresse: hello(at)storylinerlabs.com"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "intro",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Einf\xfchrung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Grunds\xe4tzliche Angaben zur Datenverarbeitung und Rechtsgrundlagen"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Diese Datenschutzerkl\xe4rung kl\xe4rt dich \xfcber die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte (nachfolgend gemeinsam bezeichnet als „Onlineangebot“ oder „Website“) auf. Die Datenschutzerkl\xe4rung gilt unabh\xe4ngig von den verwendeten Domains, Systemen, Plattformen und Ger\xe4ten (z.B. Desktop oder Mobile) auf denen das Onlineangebot ausgef\xfchrt wird."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die verwendeten Begrifflichkeiten, wie z.B. „personenbezogene Daten“ oder deren „Verarbeitung“ verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO)."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Zu den im Rahmen dieses Onlineangebotes verarbeiteten personenbezogenen Daten der Nutzer geh\xf6ren Bestandsdaten (z.B. Namen und Adressen von Kunden), Vertragsdaten (z.B. in Anspruch genommene Leistungen, Namen von Sachbearbeitern, Zahlungsinformationen), Nutzungsdaten (z.B. die besuchten Webseiten unseres Onlineangebotes, Interesse an unseren Produkten) und Inhaltsdaten (z.B. Eingaben im Kontaktformular)."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Der Begriff „Nutzer“ umfasst alle Kategorien von der Datenverarbeitung betroffener Personen. Zu ihnen geh\xf6ren unsere Gesch\xe4ftspartner, Kunden, Interessenten und sonstige Besucher unseres Onlineangebotes. Die verwendeten Begrifflichkeiten, wie z.B. „Nutzer“ sind geschlechtsneutral zu verstehen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verarbeiten personenbezogene Daten der Nutzer nur unter Einhaltung der einschl\xe4gigen Datenschutzbestimmungen. Das bedeutet, die Daten der Nutzer werden nur bei Vorliegen einer gesetzlichen Erlaubnis verarbeitet. D.h., insbesondere wenn die Datenverarbeitung zur Erbringung unserer vertraglichen Leistungen (z.B. Bearbeitung von Auftr\xe4gen) sowie Online-Services erforderlich, bzw. gesetzlich vorgeschrieben ist, eine Einwilligung der Nutzer vorliegt, als auch aufgrund unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb und Sicherheit unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO, insbesondere bei der Reichweitenmessung, Erstellung von Profilen zu Werbe- und Marketingzwecken sowie Erhebung von Zugriffsdaten und Einsatz der Dienste von Drittanbietern."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir weisen darauf hin, dass die Rechtsgrundlage der Einwilligungen Art. 6 Abs. 1 lit. a. und Art. 7 DSGVO, die Rechtsgrundlage f\xfcr die Verarbeitung zur Erf\xfcllung unserer Leistungen und Durchf\xfchrung vertraglicher Ma\xdfnahmen Art. 6 Abs. 1 lit. b. DSGVO, die Rechtsgrundlage f\xfcr die Verarbeitung zur Erf\xfcllung unserer rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c. DSGVO, und die Rechtsgrundlage f\xfcr die Verarbeitung zur Wahrung unserer berechtigten Interessen Art. 6 Abs. 1 lit. f. DSGVO ist."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Rechte der Nutzer"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Nutzer haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten \xfcber die personenbezogenen Daten, die von uns \xfcber sie gespeichert wurden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Zus\xe4tzlich haben die Nutzer das Recht auf Berichtigung unrichtiger Daten, Einschr\xe4nkung der Verarbeitung und L\xf6schung ihrer personenbezogenen Daten, sofern zutreffend, ihre Rechte auf Datenportabilit\xe4t geltend zu machen und im Fall der Annahme einer unrechtm\xe4\xdfigen Datenverarbeitung, eine Beschwerde bei der zust\xe4ndigen Aufsichtsbeh\xf6rde einzureichen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Ebenso k\xf6nnen Nutzer Einwilligungen, grunds\xe4tzlich mit Auswirkung f\xfcr die Zukunft, widerrufen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "L\xf6schung von Daten"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die bei uns gespeicherten Daten werden gel\xf6scht, sobald sie f\xfcr ihre Zweckbestimmung nicht mehr erforderlich sind und der L\xf6schung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten der Nutzer nicht gel\xf6scht werden, weil sie f\xfcr andere und gesetzlich zul\xe4ssige Zwecke erforderlich sind, wird deren Verarbeitung eingeschr\xe4nkt. D.h. die Daten werden gesperrt und nicht f\xfcr andere Zwecke verarbeitet. Das gilt z.B. f\xfcr Daten der Nutzer, die aus handels- oder steuerrechtlichen Gr\xfcnden aufbewahrt werden m\xfcssen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Nach gesetzlichen Vorgaben erfolgt die Aufbewahrung f\xfcr 6 Jahre gem\xe4\xdf \xa7 257 Abs. 1 HGB (Handelsb\xfccher, Inventare, Er\xf6ffnungsbilanzen, Jahresabschl\xfcsse, Handelsbriefe, Buchungsbelege, etc.) sowie f\xfcr 10 Jahre gem\xe4\xdf \xa7 147 Abs. 1 AO (B\xfccher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handels- und Gesch\xe4ftsbriefe, F\xfcr Besteuerung relevante Unterlagen, etc.)."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Widerspruchsrecht"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Nutzer k\xf6nnen der k\xfcnftigen Verarbeitung ihrer personenbezogenen Daten entsprechend den gesetzlichen Vorgaben jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung f\xfcr Zwecke der Direktwerbung erfolgen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "\xc4nderungen der Datenschutzerkl\xe4rung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir behalten uns vor, die Datenschutzerkl\xe4rung zu \xe4ndern, um sie an ge\xe4nderte Rechtslagen, oder bei \xc4nderungen des Dienstes sowie der Datenverarbeitung anzupassen. Dies gilt jedoch nur im Hinblick auf Erkl\xe4rungen zur Datenverarbeitung. Sofern Einwilligungen der Nutzer erforderlich sind oder Bestandteile der Datenschutzerkl\xe4rung Regelungen des Vertragsverh\xe4ltnisses mit den Nutzern enthalten, erfolgen die \xc4nderungen nur mit Zustimmung der Nutzer."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Nutzer werden gebeten sich regelm\xe4\xdfig \xfcber den Inhalt der Datenschutzerkl\xe4rung zu informieren."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "security",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Sicherheitsma\xdfnahmen"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir treffen organisatorische, vertragliche und technische Sicherheitsma\xdfnahmen entsprechend dem Stand der Technik, um sicherzustellen, dass die Vorschriften der Datenschutzgesetze eingehalten werden und um damit die durch uns verarbeiteten Daten gegen zuf\xe4llige oder vors\xe4tzliche Manipulationen, Verlust, Zerst\xf6rung oder gegen den Zugriff unberechtigter Personen zu sch\xfctzen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Zu den Sicherheitsma\xdfnahmen geh\xf6rt insbesondere die verschl\xfcsselte \xdcbertragung von Daten zwischen deinem Browser und unserem Server."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "data-transfer",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Datenweitergabe"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Eine Weitergabe von Daten an Dritte erfolgt nur im Rahmen der gesetzlichen Vorgaben. Wir geben die Daten der Nutzer an Dritte nur dann weiter, wenn dies z.B. auf Grundlage des Art. 6 Abs. 1 lit. b) DSGVO f\xfcr Vertragszwecke erforderlich ist oder auf Grundlage berechtigter Interessen gem. Art. 6 Abs. 1 lit. f. DSGVO an wirtschaftlichem und effektivem Betrieb unseres Gesch\xe4ftsbetriebes."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Sofern wir Subunternehmer einsetzen, um unsere Leistungen bereitzustellen, ergreifen wir geeignete rechtliche Vorkehrungen sowie entsprechende technische und organisatorische Ma\xdfnahmen, um f\xfcr den Schutz der personenbezogenen Daten gem\xe4\xdf den einschl\xe4gigen gesetzlichen Vorschriften zu sorgen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Sofern im Rahmen dieser Datenschutzerkl\xe4rung Inhalte, Werkzeuge oder sonstige Mittel, von anderen Anbietern (nachfolgend gemeinsam bezeichnet als „Drittanbieter“) eingesetzt werden und deren genannter Sitz sich in einem Drittland befindet, ist davon auszugehen, dass ein Datentransfer in die Sitzstaaten der Drittanbieter stattfindet. Als Drittstaaten sind L\xe4nder zu verstehen, in denen die DSGVO kein unmittelbar geltendes Recht ist, d.h. grunds\xe4tzlich L\xe4nder au\xdferhalb der EU, bzw. des Europ\xe4ischen Wirtschaftsraums. Die \xdcbermittlung von Daten in Drittstaaten erfolgt entweder, wenn ein angemessenes Datenschutzniveau, eine Einwilligung der Nutzer oder sonst eine gesetzliche Erlaubnis vorliegt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "service-provision",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Leistungserbringung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verarbeiten Bestandsdaten (z.B. Namen und Adressen sowie Kontaktdaten von Nutzern), Vertragsdaten (z.B., in Anspruch genommene Leistungen, Namen von Kontaktpersonen, Zahlungsinformationen) zwecks Erf\xfcllung unserer vertraglichen Verpflichtungen und Serviceleistungen gem. Art. 6 Abs. 1 lit b. DSGVO."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Nutzer k\xf6nnen optional ein Nutzerkonto anlegen, indem sie insbesondere ihre Bestellungen einsehen k\xf6nnen. Im Rahmen der Registrierung, werden die erforderlichen Pflichtangaben den Nutzern mitgeteilt. Die Nutzerkonten sind nicht \xf6ffentlich und k\xf6nnen von Suchmaschinen nicht indexiert werden. Wenn Nutzer ihr Nutzerkonto gek\xfcndigt haben, werden deren Daten im Hinblick auf das Nutzerkonto gel\xf6scht, vorbehaltlich deren Aufbewahrung ist aus handels- oder steuerrechtlichen Gr\xfcnden entspr. Art. 6 Abs. 1 lit. c DSGVO notwendig. Es obliegt den Nutzern, ihre Daten bei erfolgter K\xfcndigung vor dem Vertragsende zu sichern. Wir sind berechtigt, s\xe4mtliche w\xe4hrend der Vertragsdauer gespeicherten Daten des Nutzers unwiederbringlich zu l\xf6schen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Im Rahmen der Registrierung und erneuter Anmeldungen sowie Inanspruchnahme unserer Onlinedienste, speichern wird die IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung. Die Speicherung erfolgt auf Grundlage unserer berechtigten Interessen, als auch der Nutzer an Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grunds\xe4tzlich nicht, au\xdfer sie ist zur Verfolgung unserer Anspr\xfcche erforderlich oder es besteht hierzu besteht eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1 lit. c DSGVO."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verarbeiten Nutzungsdaten (z.B., die besuchten Webseiten unseres Onlineangebotes, Interesse an unseren Produkten) und Inhaltsdaten (z.B., Eingaben im Kontaktformular oder Nutzerprofil) f\xfcr Werbezwecke in einem Nutzerprofil, um den Nutzer z.B. Produkthinweise ausgehend von ihren bisher in Anspruch genommenen Leistungen einzublenden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "communication",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Kommunikation"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Kontaktaufnahme"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Bei der Kontaktaufnahme mit uns (per Kontaktformular oder E-Mail) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1 lit. b) DSGVO verarbeitet."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Angaben der Nutzer k\xf6nnen in unserem Customer-Relationship-Management System (”CRM System”) oder vergleichbarer Anfragenorganisation gespeichert werden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Kommentare und Beitr\xe4ge"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wenn Nutzer Kommentare oder sonstige Beitr\xe4ge hinterlassen, werden ihre IP-Adressen auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO f\xfcr 7 Tage gespeichert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Das erfolgt zu unserer Sicherheit, falls jemand in Kommentaren und Beitr\xe4gen widerrechtliche Inhalte hinterl\xe4sst (Beleidigungen, verbotene politische Propaganda, etc.). In diesem Fall k\xf6nnen wir selbst f\xfcr den Kommentar oder Beitrag belangt werden und sind daher an der Identit\xe4t des Verfassers interessiert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Angaben der Nutzer k\xf6nnen in unserem Kommentar-System oder vergleichbarer Anfragenorganisation gespeichert werden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "E-Mail-Kommunikation und Newsletter"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Mit den nachfolgenden Hinweisen kl\xe4ren wir dich \xfcber die Inhalte unseres Newsletters sowie das Anmelde-, Versand- und das statistische Auswertungsverfahren sowie deine Widerspruchsrechte auf. Indem du unseren Newsletter abonnierst, erkl\xe4rst du dich mit dem Empfang und den beschriebenen Verfahren einverstanden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir versenden Newsletter, E-Mails und weitere elektronische Benachrichtigungen mit werblichen Informationen (nachfolgend „Newsletter“) nur mit der Einwilligung der Empf\xe4nger oder einer gesetzlichen Erlaubnis. Sofern im Rahmen einer Anmeldung zum Newsletter dessen Inhalte konkret umschrieben werden, sind sie f\xfcr die Einwilligung der Nutzer ma\xdfgeblich. Im \xdcbrigen enthalten unsere Newsletter Informationen zu unseren Produkten, Angeboten, Aktionen und unserem Unternehmen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Anmeldung zu unserem Newsletter erfolgt in einem sog. Double-Opt-In-Verfahren. D.h. du erh\xe4lst nach der Anmeldung eine E-Mail, in der du um die Best\xe4tigung deiner Anmeldung gebeten wirst. Diese Best\xe4tigung ist notwendig, damit sich niemand mit fremden E-Mail-Adressen anmelden kann. Die Anmeldungen zum Newsletter werden protokolliert, um den Anmeldeprozess entsprechend den rechtlichen Anforderungen nachweisen zu k\xf6nnen. Hierzu geh\xf6rt die Speicherung des Anmelde- und des Best\xe4tigungszeitpunkts, als auch der IP-Adresse. Ebenso werden die \xc4nderungen Deiner bei dem Versanddienstleister gespeicherten Daten protokolliert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Des Weiteren kann der Versanddienstleister nach eigenen Informationen diese Daten in pseudonymer Form, d.h. ohne Zuordnung zu einem Nutzer, zur Optimierung oder Verbesserung der eigenen Services nutzen, z.B. zur technischen Optimierung des Versandes und der Darstellung der Newsletter oder f\xfcr statistische Zwecke, um zu bestimmen aus welchen L\xe4ndern die Empf\xe4nger kommen, verwenden. Der Versanddienstleister nutzt die Daten unserer Newsletterempf\xe4nger jedoch nicht, um diese selbst anzuschreiben oder an Dritte weiterzugeben."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Um sich f\xfcr den Newsletter anzumelden, reicht es aus, wenn du deine E-Mail-Adresse angibst."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Newsletter enthalten einen sog. „web-beacon“, d.h. eine pixelgro\xdfe Datei, die beim \xd6ffnen des Newsletters von dem Server des Versanddienstleisters abgerufen wird. Im Rahmen dieses Abrufs werden zun\xe4chst technische Informationen, wie Informationen zum Browser und deinem System, als auch deine IP-Adresse und Zeitpunkt des Abrufs erhoben. Diese Informationen werden zur technischen Verbesserung der Services anhand der technischen Daten oder der Zielgruppen und ihres Leseverhaltens anhand derer Abruforte (die mit Hilfe der IP-Adresse bestimmbar sind) oder der Zugriffszeiten genutzt. Zu den statistischen Erhebungen geh\xf6rt ebenfalls die Feststellung, ob die Newsletter ge\xf6ffnet werden, wann sie ge\xf6ffnet werden und welche Links geklickt werden. Diese Informationen k\xf6nnen aus technischen Gr\xfcnden zwar den einzelnen Newsletterempf\xe4ngern zugeordnet werden. Es ist jedoch weder unser Bestreben, noch das des Versanddienstleisters, einzelne Nutzer zu beobachten. Die Auswertungen dienen uns viel mehr dazu, die Lesegewohnheiten unserer Nutzer zu erkennen und unsere Inhalte auf sie anzupassen oder unterschiedliche Inhalte entsprechend den Interessen unserer Nutzer zu versenden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Der Einsatz des Versanddienstleisters, Durchf\xfchrung der statistischen Erhebungen und Analysen sowie Protokollierung des Anmeldeverfahrens, erfolgen auf Grundlage unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f DSGVO. Unser Interesse richtet sich auf den Einsatz eines nutzerfreundlichen sowie sicheren Newslettersystems, das sowohl unseren gesch\xe4ftlichen Interessen dient, als auch den Erwartungen der Nutzer entspricht."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Du kannst den Empfang unseres Newsletters jederzeit k\xfcndigen, d.h. deine Einwilligungen widerrufen. Damit erl\xf6schen gleichzeitig deine Einwilligungen in dessen Versand durch den Versanddienstleister und die statistischen Analysen. Ein getrennter Widerruf des Versandes durch den Versanddienstleister oder die statistische Auswertung ist leider nicht m\xf6glich. Einen Link zur K\xfcndigung des Newsletters findest du am Ende eines jeden Newsletters. Wenn die Nutzer sich nur zum Newsletter angemeldet und diese Anmeldung gek\xfcndigt haben, werden ihre personenbezogenen Daten gel\xf6scht."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Entsprechend den Vorgaben der ab dem 25. Mai 2018 geltenden Datenschutzgrundverordnung (DSGVO) informieren wir dich, dass die Einwilligungen in den Versand der E-Mailadressen auf Grundlage der Art. 6 Abs. 1 lit. a, 7 DSGVO sowie \xa7 7 Abs. 2 Nr. 3, bzw. Abs. 3 UWG erfolgt. Der Einsatz des Versanddienstleisters, Durchf\xfchrung der statistischen Erhebungen und Analysen sowie Protokollierung des Anmeldeverfahrens, erfolgen auf Grundlage unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f DSGVO. Unser Interesse richtet sich auf den Einsatz eines nutzerfreundlichen sowie sicheren Newslettersystems, das sowohl unseren gesch\xe4ftlichen Interessen dient, als auch den Erwartungen der Nutzer entspricht. Wir weisen dich ferner darauf hin, dass dich der k\xfcnftigen Verarbeitung deiner personenbezogenen Daten entsprechend den gesetzlichen Vorgaben gem. Art. 21 DSGVO jederzeit widersprechen k\xf6nnen. Der Widerspruch kann insbesondere gegen die Verarbeitung f\xfcr Zwecke der Direktwerbung erfolgen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "data-collection",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Datenerhebung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Erhebung von Zugriffsdaten und Logfiles"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir erheben auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten \xfcber jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten geh\xf6ren Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, \xfcbertragene Datenmenge, Meldung \xfcber erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Logfile-Informationen werden aus Sicherheitsgr\xfcnden (z.B. zur Aufkl\xe4rung von Missbrauchs- oder Betrugshandlungen) f\xfcr die Dauer von maximal sieben Tagen gespeichert und danach gel\xf6scht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endg\xfcltigen Kl\xe4rung des jeweiligen Vorfalls von der L\xf6schung ausgenommen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Cookies & Reichweitenmessung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Cookies sind Informationen, die von unserem Webserver oder Webservern Dritter an die Web-Browser der Nutzer \xfcbertragen und dort f\xfcr einen sp\xe4teren Abruf gespeichert werden. Bei Cookies kann es sich um kleine Dateien oder sonstige Arten der Informationsspeicherung handeln."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verwenden „Session-Cookies“, die nur f\xfcr die Zeitdauer des aktuellen Besuchs auf unserer Onlinepr\xe4senz abgelegt werden (z.B. um die Speicherung deines Login-Status oder die Warenkorbfunktion und somit die Nutzung unseres Onlineangebotes \xfcberhaupt erm\xf6glichen zu k\xf6nnen). In einem Session-Cookie wird eine zuf\xe4llig erzeugte eindeutige Identifikationsnummer abgelegt, eine sogenannte Session-ID. Au\xdferdem enth\xe4lt ein Cookie die Angabe \xfcber seine Herkunft und die Speicherfrist. Diese Cookies k\xf6nnen keine anderen Daten speichern. Session-Cookies werden gel\xf6scht, wenn du die Nutzung unseres Onlineangebotes beendet hast und dich z.B. ausloggst oder den Browser schlie\xdft."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "\xdcber den Einsatz von Cookies im Rahmen pseudonymer Reichweitenmessung werden die Nutzer im Rahmen dieser Datenschutzerkl\xe4rung informiert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Falls die Nutzer nicht m\xf6chten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies k\xf6nnen in den Systemeinstellungen des Browsers gel\xf6scht werden. Der Ausschluss von Cookies kann zu Funktionseinschr\xe4nkungen dieses Onlineangebotes f\xfchren."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Du kannst dem Einsatz von Cookies, die der Reichweitenmessung und Werbezwecken dienen, \xfcber unsere Cookie-Einstellungsseite, \xfcber die Deaktivierungsseite der Netzwerkwerbeinitiative und zus\xe4tzlich die US-amerikanische Webseite oder die europ\xe4ische Webseite widersprechen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function() {
                                return window.cookiehub.openSettings();
                            },
                            children: "Unsere Cookie-Einstellungen"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://optout.networkadvertising.org/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Deaktivierungsseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.aboutads.info/choices",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "US-amerikanische Webseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.youronlinechoices.com/uk/your-ad-choices/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Europ\xe4ische Webseite der Netzwerkwerbeinitiative"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                sectionId: "services",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "72px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Verwendete Dienste"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Einbindung von Diensten und Inhalten Dritter"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als “Inhalte”). Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden k\xf6nnten. Die IP-Adresse ist damit f\xfcr die Darstellung dieser Inhalte erforderlich. Wir bem\xfchen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter k\xf6nnen ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als “Web Beacons” bezeichnet) f\xfcr statistische oder Marketingzwecke verwenden. Durch die ”Pixel-Tags” k\xf6nnen Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen k\xf6nnen ferner in Cookies auf dem Ger\xe4t der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden k\xf6nnen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die nachfolgende Darstellung bietet eine \xdcbersicht von Drittanbietern sowie ihrer Inhalte, nebst Links zu deren Datenschutzerkl\xe4rungen, welche weitere Hinweise zur Verarbeitung von Daten und, z.T. bereits hier genannt, Widerspruchsm\xf6glichkeiten (sog. Opt-Out) enthalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Google Tag Manager"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Als Tag Management System und f\xfcr das Verwalten von Webseiten-Tags verwenden wir auf unserem Internetauftritt den ”Google Tag Manager”, einen Dienst der Google Ireland Limited, Gordon House, BarrowStreet, Dublin 4, Irland. Das Tool Google Tag Manager, welches die Tags auf der Website implementiert, ist eine cookielose Domain und erfasst selbst keine personenbezogenen Daten. Der Dienst sorgt f\xfcr die Ausl\xf6sung anderer Tags, die ihrerseits unter Umst\xe4nden Daten erfassen. Google Tag Manager selbst greift nicht auf diese Daten zu. Wenn auf Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen wurde, bleibt diese f\xfcr alle Tracking-Tags bestehen, die mit Google Tag Manager implementiert werden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xe4ische Datenschutzrecht einzuhalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Informationen zum Datenschutz oder zum Dienst selbst kannst du den nachfolgenden Webseiten von Google entnehmen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Privacy Shield Google"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.de/intl/de/policies/privacy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzerkl\xe4rung Google"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/intl/de/tagmanager/faq.html",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Fragen zum Google Tag Manager"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/intl/de/tagmanager/use-policy.html",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Nutzungsbedingungen Google Tag Manager"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Google Analytics"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir setzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Google Analytics, einen Webanalysedienst der Google Inc. („Google“) ein. Google verwendet Cookies. Die durch das Cookie erzeugten Informationen \xfcber Benutzung des Onlineangebotes durch die Nutzer werden in der Regel an einen Server von Google in den USA \xfcbertragen und dort gespeichert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xe4ische Datenschutzrecht einzuhalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Google wird diese Informationen in unserem Auftrag benutzen, um die Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um Reports \xfcber die Aktivit\xe4ten innerhalb dieses Onlineangebotes zusammenzustellen und um weitere, mit der Nutzung dieses Onlineangebotes und der Internetnutzung verbundene Dienstleistungen, uns gegen\xfcber zu erbringen. Dabei k\xf6nnen aus den verarbeiteten Daten pseudonyme Nutzungsprofile der Nutzer erstellt werden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir setzen Google Analytics nur mit aktivierter IP-Anonymisierung ein. Das bedeutet, die IP-Adresse der Nutzer wird von Google innerhalb von Mitgliedstaaten der Europ\xe4ischen Union oder in anderen Vertragsstaaten des Abkommens \xfcber den Europ\xe4ischen Wirtschaftsraum gek\xfcrzt. Nur in Ausnahmef\xe4llen wird die volle IP-Adresse an einen Server von Google in den USA \xfcbertragen und dort gek\xfcrzt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die von dem Browser des Nutzers \xfcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xfchrt. Die Nutzer k\xf6nnen die Speicherung der Cookies durch eine entsprechende Einstellung ihrer Browser-Software verhindern; die Nutzer k\xf6nnen dar\xfcber hinaus die Erfassung der durch das Cookie erzeugten und auf ihre Nutzung des Onlineangebotes bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter nachfolgendem Verweis verf\xfcgbare Browser-Plugin herunterladen und installieren."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Du kannst die Erfassung deiner Daten durch Google Analytics verhindern, indem du auf nachfolgenden Link klickst. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung deiner Daten bei zuk\xfcnftigen Besuchen dieser Website verhindert. L\xf6schst du deine Cookies, musst du diesen Link erneut klicken."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Weitere Informationen zur Datennutzung durch Google, Einstellungs- und Widerspruchsm\xf6glichkeiten bekommst du auf den Webseiten von Google."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Privacy Shield Google"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://tools.google.com/dlpage/gaoptout?hl=de",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Google Browser Plugin"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            id: "gaOptOut",
                            type: "button",
                            children: "Google Analytics Opt-Out"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/policies/technologies/ads",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Googles Datennutzung zu Werbezwecken"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/intl/de/policies/privacy/partners",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datennutzung durch Google beim Verwenden von Websites durch Partner"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.de/settings/ads",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Informationen verwalten, die Google verwendet, um Werbung einzublenden"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Facebook Social Plugins"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir nutzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Social Plugins (”Plugins”) des sozialen Netzwerkes facebook.com, welches von der Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland betrieben wird (“Facebook”). Die Plugins k\xf6nnen Interaktionselemente oder Inhalte (z.B. Videos, Grafiken oder Textbeitr\xe4ge) darstellen und sind an einem der Facebook Logos erkennbar (wei\xdfes „f“ auf blauer Kachel, den Begriffen ”Like”, ”Gef\xe4llt mir” oder einem „Daumen hoch“-Zeichen) oder sind mit dem Zusatz ”Facebook Social Plugin” gekennzeichnet. Die Liste und das Aussehen der Facebook Social Plugins kann unter nachfolgenden Verweis eingesehen werden."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Facebook ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xe4ische Datenschutzrecht einzuhalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wenn ein Nutzer eine Funktion dieses Onlineangebotes aufruft, die ein solches Plugin enth\xe4lt, baut sein Ger\xe4t eine direkte Verbindung mit den Servern von Facebook auf. Der Inhalt des Plugins wird von Facebook direkt an das Ger\xe4t des Nutzers \xfcbermittelt und von diesem in das Onlineangebot eingebunden. Dabei k\xf6nnen aus den verarbeiteten Daten Nutzungsprofile der Nutzer erstellt werden. Wir haben daher keinen Einfluss auf den Umfang der Daten, die Facebook mit Hilfe dieses Plugins erhebt und informiert die Nutzer daher entsprechend unserem Kenntnisstand."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Durch die Einbindung der Plugins erh\xe4lt Facebook die Information, dass ein Nutzer die entsprechende Seite des Onlineangebotes aufgerufen hat. Ist der Nutzer bei Facebook eingeloggt, kann Facebook den Besuch seinem Facebook-Konto zuordnen. Wenn Nutzer mit den Plugins interagieren, zum Beispiel den Like Button bet\xe4tigen oder einen Kommentar abgeben, wird die entsprechende Information von Deinem Ger\xe4t direkt an Facebook \xfcbermittelt und dort gespeichert. Falls ein Nutzer kein Mitglied von Facebook ist, besteht trotzdem die M\xf6glichkeit, dass Facebook seine IP-Adresse in Erfahrung bringt und speichert. Laut Facebook wird in Deutschland nur eine anonymisierte IP-Adresse gespeichert."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und Nutzung der Daten durch Facebook sowie die diesbez\xfcglichen Rechte und Einstellungsm\xf6glichkeiten zum Schutz der Privatsph\xe4re der Nutzer, k\xf6nnen diese den Datenschutzhinweisen von Facebook entnehmen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wenn ein Nutzer Facebookmitglied ist und nicht m\xf6chte, dass Facebook \xfcber dieses Onlineangebot Daten \xfcber ihn sammelt und mit seinen bei Facebook gespeicherten Mitgliedsdaten verkn\xfcpft, muss er sich vor der Nutzung unseres Onlineangebotes bei Facebook ausloggen und seine Cookies l\xf6schen. Weitere Einstellungen und Widerspr\xfcchezur Nutzung von Daten f\xfcr Werbezwecke, sind innerhalb der Facebook-Profileinstellungen m\xf6glich oder \xfcber die US-amerikanische Seite oder die EU-Seite. Die Einstellungen erfolgen plattformunabh\xe4ngig, d.h. sie werden f\xfcr alle Ger\xe4te, wie Desktopcomputer oder mobile Ger\xe4te \xfcbernommen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://developers.facebook.com/docs/plugins/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Liste und das Aussehen der Facebook Social Plugins"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Privacy Shield Facebook"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/about/privacy/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzhinweisen Facebook"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/settings?tab=ads",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Facebook-Profil-Einstellungen"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://optout.networkadvertising.org/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Deaktivierungsseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.aboutads.info/choices",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "US-amerikanische Webseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.youronlinechoices.com/uk/your-ad-choices/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Europ\xe4ische Webseite der Netzwerkwerbeinitiative"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Facebook-, Custom Audiences und Facebook-Marketing-Dienste"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Innerhalb unseres Onlineangebotes wird aufgrund unserer berechtigten Interessen an Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes und zu diesen Zwecken das sog. ”Facebook-Pixel” des sozialen Netzwerkes Facebook, welches von der Facebook Inc., 1 Hacker Way, Menlo Park, CA 94025, USA, bzw. falls du in der EU ans\xe4ssig bist, Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland betrieben wird (”Facebook”), eingesetzt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Facebook ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xe4ische Datenschutzrecht einzuhalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Mit Hilfe des Facebook-Pixels ist es Facebook zum einen m\xf6glich, die Besucher unseres Onlineangebotes als Zielgruppe f\xfcr die Darstellung von Anzeigen (sog. ”Facebook-Ads”) zu bestimmen. Dementsprechend setzen wir das Facebook-Pixel ein, um die durch uns geschalteten Facebook-Ads nur solchen Facebook-Nutzern anzuzeigen, die auch ein Interesse an unserem Onlineangebot gezeigt haben oder die bestimmte Merkmale (z.B. Interessen an bestimmten Themen oder Produkten, die anhand der besuchten Webseiten bestimmt werden) aufweisen, die wir an Facebook \xfcbermitteln (sog. „Custom Audiences“). Mit Hilfe des Facebook-Pixels m\xf6chten wir auch sicherstellen, dass unsere Facebook-Ads dem potentiellen Interesse der Nutzer entsprechen und nicht bel\xe4stigend wirken. Mit Hilfe des Facebook-Pixels k\xf6nnen wir ferner die Wirksamkeit der Facebook-Werbeanzeigen f\xfcr statistische und Marktforschungszwecke nachvollziehen, in dem wir sehen ob Nutzer nachdem Klick auf eine Facebook-Werbeanzeige auf unsere Website weitergeleitet wurden (sog. „Conversion“)."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Das Facebook-Pixel wird beim Aufruf unserer Webseiten unmittelbar durch Facebook eingebunden und kann auf Deinem Ger\xe4t ein sog. Cookie, d.h. eine kleine Datei abspeichern. Wenn du dich anschlie\xdfend bei Facebook einloggst oder im eingeloggten Zustand Facebook besuchst, wird der Besuch unseres Onlineangebotes in Deinem Profil vermerkt. Die \xfcber Deine erhobenen Daten sind f\xfcr uns anonym, bieten uns also keine R\xfcckschl\xfcsse auf die Identit\xe4t der Nutzer. Allerdings werden die Daten von Facebook gespeichert und verarbeitet, sodass eine Verbindung zum jeweiligen Nutzerprofil m\xf6glich ist und von Facebook sowie zu eigenen Marktforschungs- und Werbezwecken verwendet werden kann. Sofern wir Daten zu Abgleichzwecken an Facebook \xfcbermitteln sollten, werden diese lokal in auf dem Browser verschl\xfcsselt und erst dann an Facebook \xfcber eine gesicherte https-Verbindung gesendet. Dies erfolgt alleine mit dem Zweck, einen Abgleich mit den gleicherma\xdfen durch Facebook verschl\xfcsselten Daten herzustellen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Verarbeitung der Daten durch Facebook erfolgt im Rahmen von Facebooks Datenverwendungsrichtlinie. Dementsprechend findest du dort generelle Hinweise zur Darstellung von Facebook-Ads. Spezielle Informationen und Details zum Facebook-Pixel und seiner Funktionsweise erh\xe4lst du im Hilfebereich von Facebook."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Du kannst der Erfassung durch den Facebook-Pixel und Verwendung Deiner Daten zur Darstellung von Facebook-Ads widersprechen. Um einzustellen, welche Arten von Werbeanzeigen Dir innerhalb von Facebook wird, kannst du die von Facebook eingerichtete Seite aufrufen und dort die Hinweise zu den Einstellungen nutzungsbasierter Werbung befolgen. Die Einstellungen erfolgen plattformunabh\xe4ngig, d.h. sie werden f\xfcr alle Ger\xe4te, wie Desktopcomputer oder mobile Ger\xe4te \xfcbernommen. Um der Erfassung Deiner Daten mittels des Facebook-Pixels auf unserer Webseite zu verhindern, klicke bitte den nachfolgeden Link. Hinweis: Wenn du den Link klickst, wird ein „Opt-Out“-Cookie auf diesem Ger\xe4t gespeichert. Wenn du die Cookies in diesem Browser l\xf6scht, dann musst du den Link erneut klicken. Ferner gilt das Opt-Out nur innerhalb des von Dir verwendeten Browsers und nur innerhalb unserer Webdomain, auf der der Link geklickt wurde."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Du kannst dem Einsatz von Cookies, die der Reichweitenmessung und Werbezwecken dienen, ferner \xfcber die Deaktivierungsseite der Netzwerkwerbeinitiative und zus\xe4tzlich die US-amerikanische Webseite oder die europ\xe4ische Webseite widersprechen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Privacy Shield Facebook"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/policy.php",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenverwendungsrichtlinie Facebook"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/business/help/651294705016616",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Hilfebereich von Facebook zum Facebook Pixel"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/settings?tab=ads",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Facebook Einstellungen f\xfcr nutzungsbasierte Werbung"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            id: "faOptOut",
                            type: "button",
                            children: "Facebook Opt-Out"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://optout.networkadvertising.org/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Deaktivierungsseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.aboutads.info/choices",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "US-amerikanische Webseite der Netzwerkwerbeinitiative"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.youronlinechoices.com/uk/your-ad-choices/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Europ\xe4ische Webseite der Netzwerkwerbeinitiative"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "ActiveCampaign"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Der Versand der Newsletter und von E-Mails erfolgt mittels ActiveCampaign, ActiveCampaign, LLC, 150 N. Michigan Ave Suite 1230, Chicago, IL, US, USA. ActiveCampaign ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xe4isches Datenschutzniveau einzuhalten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Mit Hilfe von ActiveCampaign k\xf6nnen wir unsere Newsletterkampagnen analysieren. Wenn du eine mit ActiveCampaign versandte E-Mail \xf6ffnest, verbindet sich eine in der E-Mail enthaltene Datei (sog. web-beacon) mit den Servern von ActiveCampaign in den USA. So kann festgestellt werden, ob eine Newsletter-Nachricht ge\xf6ffnet und welche Links ggf. angeklickt wurden. Au\xdferdem werden technische Informationen erfasst (z.B. Zeitpunkt des Abrufs, IP-Adresse, Browsertyp und Betriebssystem). Diese Informationen k\xf6nnen nicht dem jeweiligen Newsletter-Empf\xe4nger zugeordnet werden. Sie dienen ausschlie\xdflich der statistischen Analyse von Newsletterkampagnen. Die Ergebnisse dieser Analysen k\xf6nnen genutzt werden, um k\xfcnftige Newsletter besser an die Interessen der Empf\xe4nger anzupassen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Datenverarbeitung erfolgt auf Grundlage deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). du kannst diese Einwilligung jederzeit widerrufen, indem du den Newsletter abbestellst. Die Rechtm\xe4\xdfigkeit der bereits erfolgten Datenverarbeitungsvorg\xe4nge bleibt vom Widerruf unber\xfchrt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die von dir zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu deiner Austragung aus dem Newsletter gespeichert und nach der Abbestellung des Newsletters sowohl von unseren Servern als auch von den Servern von ActiveCampaign gel\xf6scht. Daten, die zu anderen Zwecken bei uns gespeichert wurden (z.B. E-Mail-Adressen f\xfcr den Mitgliederbereich) bleiben hiervon unber\xfchrt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.activecampaign.com/legal/privacy-policy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzerkl\xe4rung ActiveCampaign"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.privacyshield.gov/participant?id=a2zt0000000GnH6AAK",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Privacy Shield ActiveCampagin"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Hotjar"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verwenden auf unserer Webseite ”Hotjar”, einen Webanalysedienst der Hotjar Ltd., Level 2, St Julian's Business Centre, 3, Elia Zammit Street, St Julian's STJ 1000, Malta. Mit Hotjar ist es m\xf6glich das Nutzungsverhalten (Klicks, Mausbewegungen, Scrollh\xf6hen, etc.) auf unserer Website zu messen und auszuwerten. Hotjar generiert Informationen durch den auf der Website eingebundenen „Tracking Code“ und \xfcber kleine Textdateien (Cookies), die lokal im Zwischenspeicher Deines Webbrowsers auf Deinem Endger\xe4t gespeichert werden und die eine Analyse der Benutzung unserer Webseite erm\xf6glichen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir verwenden Hotjar zu dem Zweck, die Nutzung unserer Webseite analysieren und einzelne Funktionen und Angebote sowie das Nutzungserlebnis fortlaufend verbessern zu k\xf6nnen. Durch die statistische Auswertung des Nutzerverhaltens k\xf6nnen wir unser Angebot verbessern und f\xfcr Dich als Nutzer interessanter ausgestalten. Hierin liegt auch unser berechtigtes Interesse an der Verarbeitung der vorstehenden Daten durch Hotjar."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die durch die Cookies generierten Informationen werden an die Hotjar Server in Irland \xfcbermittelt und dort gespeichert. Die Cookies, die Hotjar nutzt, haben eine unterschiedliche „Lebensdauer“; manche bleiben bis zu 365 Tagen, manche bleiben nur w\xe4hrend des aktuellen Besuchs g\xfcltig. Die folgenden Informationen k\xf6nnen durch Dein Ger\xe4t und Deinen Browser aufgezeichnet werden: Die IP-Adresse Deines Ger\xe4tes (gesammelt und abgespeichert in einem anonymisierten Format), Deine E-Mail-Adresse inklusive Deines Vor- und Nachnamens, soweit du diese \xfcber unsere Website uns zur Verf\xfcgung gestellt hast, Bildschirmgr\xf6\xdfe Deines Ger\xe4tes, Ger\xe4tetyp und Browserinformation, geographischer Standpunkt (nur das Land), die bevorzugte Sprache um unsere Website darzustellen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Hotjar bedient sich zur Leistungserbringung auch Diensten Dritter (z.B. Google Analytics und Optimizely). Diese Drittunternehmer k\xf6nnen Informationen, die Dein Browser im Rahmen des Besuchs unserer Webseite \xfcbermittelt (unter Umst\xe4nden auch die IP-Adresse), speichern oder anderweitig verarbeiten."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Hotjar nutzt all diese Informationen, um die Nutzung unserer Webseite auszuwerten, Berichte \xfcber die Nutzung zu erstellen sowie sonstige Dienstleistungen im Zusammenhang mit der Auswertung unserer Webseite zu erbringen. du kannst die Erfassung der Daten durch Hotjar verhindern, indem du auf nachfolgenden Link klickst und die dortigen Instruktionen befolgst."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Weitere Informationen zur Datennutzung durch Hotjar, zu Einstellungs- und Widerspruchsm\xf6glichkeiten sowie zum Datenschutz kannst du der nachfolgenden Webseite von Hotjar entnehmen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.hotjar.com/legal/compliance/opt-out",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Hotjar Opt-out"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.hotjar.com/privacy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Hotjar Datenschutz"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Google Fonts"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Externe Schriftarten von Google, Inc. - „Google Fonts“. Die Einbindung der Google Fonts erfolgt durch einen Serveraufruf bei Google (in der Regel in den USA)."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://fonts.google.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Website von Google Fonts"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://policies.google.com/privacy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzerkl\xe4rung Google"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/settings/ads/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Opt-Out Google"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Google Maps"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Landkarten des Dienstes „Google Maps“ des Drittanbieters Google Inc. gestellt."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://policies.google.com/privacy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzerkl\xe4rung Google"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/settings/ads/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Opt-Out Google"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "16px"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "Youtube"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Auf einigen unserer Webseiten betten wir Youtube-Videos ein. Betreiber der entsprechenden Plugins ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Du eine Seite mit dem YouTube-Plugin besuchst, wird eine Verbindung zu Servern von Youtube hergestellt. Dabei wird Youtube mitgeteilt, welche Seiten Du besuchst. Wenn Du in Deinem Youtube-Account eingeloggt bist, kann Youtube Dein Surfverhalten pers\xf6nlich zuzuordnen. Dies verhinderst Du, indem Du Dich vorher aus Deinem Youtube-Account ausloggst. Wird ein Youtube-Video gestartet, setzt der Anbieter Cookies ein, die Hinweise \xfcber das Nutzerverhalten sammeln. Wer das Speichern von Cookies f\xfcr das Google-Ad-Programm deaktiviert hat, wird auch beim Anschauen von Youtube-Videos mit keinen solchen Cookies rechnen m\xfcssen. Youtube legt aber auch in anderen Cookies nicht-personenbezogene Nutzungsinformationen ab. M\xf6chtest Du dies verhindern, so musst Du das Speichern von Cookies im Browser blockieren."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://policies.google.com/privacy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Datenschutzerkl\xe4rung Youtube"
                        })
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.google.com/settings/ads/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Opt-Out Youtube"
                        })
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            })
        ]
    });
}
function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ }),

/***/ 7310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"storyliner-l9a5zk","storyliner-markdown-button":"storyliner-5WQeFL","storyliner-markdown-image":"storyliner-0CMuRb","responsive-iframe":"storyliner-MQtvxX","iframe-wrapper":"storyliner-s6HK1y","optin-canvas":"storyliner-xzbQ5J","info-text":"storyliner-xynJAU","icon-wrapper":"storyliner-HYoR1F","optin-button":"storyliner-0o3hOL"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"storyliner-ttPbzh"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-toc-container":"storyliner-zD80ot","storyliner-toc-menu":"storyliner-p4bsSy","storyliner-toc-item-container":"storyliner-UZZZRc","storyliner-toc-item":"storyliner-f6tDv5"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,6880,5163,9774,2888,179], function() { return __webpack_exec__(3482); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);